import { useQuery } from 'react-query';
import { authFetch } from '../../../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../../../CommonUtils/urlWithParams';
import { useClientId } from '../../../../../_hooks/useClientId';
import { useFpId } from '../../../../hooks/useFpId';
import { useIsPdf } from '../../../../hooks/useIsPdf';
import { queryKeys } from '../../../../api/queryKeys';

export interface BeneficiaryDTO {
  Name: string;
  Id: string;
  Percentage: number;
}

export interface TransferMethodDTO {
  label: string;
  value: number;
}

export interface EquityCompensationAssetDTO {
  Id: string;
  ContingentBeneficiaries: BeneficiaryDTO[] | null;
  LastUpdated: string | null;
  TransferMethod: number | TransferMethodDTO;
  Name: string;
  PrimaryBeneficiaries: BeneficiaryDTO[] | null;
  IncludedInEstatePlan: number;
}

export interface AccountAssetDTO {
  Balance: number;
  ContingentBeneficiaries: BeneficiaryDTO[] | null;
  Id: string;
  LastUpdated: string | null;
  TransferMethod: number | TransferMethodDTO;
  Name: string;
  InstitutionName: string;
  Owner: string | null;
  PrimaryBeneficiaries: BeneficiaryDTO[] | null;
  Type: number;
  TypeName: string;
  IsChecked: boolean;
}

export interface OtherAssetsAssetDTO extends AccountAssetDTO {}

export interface ExplanationDTO {
  Accounts: AccountAssetDTO[];
  EquityCompensations: EquityCompensationAssetDTO[];
  OtherAssets: OtherAssetsAssetDTO[];
}

export interface AccountAssetSimulatedDTO extends AccountAssetDTO {
  EntityId: string;
  SimulatedAccountId: string;
  SimulatedAccountType: number;
}

export interface OtherAssetsSimulatedDTO extends AccountAssetSimulatedDTO {}

export interface SimulatedExplanationDTO {
  Accounts: AccountAssetSimulatedDTO[];
  OtherAssets: OtherAssetsSimulatedDTO[];
}

export interface EstatePlanningExplanationDTO {
  Current: ExplanationDTO;
  Simulated: SimulatedExplanationDTO;
}

const fetchEstatePlanningExplanation = async ({
  clientId,
  fpId,
  isPdf,
}): Promise<EstatePlanningExplanationDTO> => {
  return authFetch(
    urlWithParams('/Consumer/EstatePlanningExplanation', {
      clientId,
      fpId,
      isPdf,
    }),
  );
};

export const useEstatePlanningExplanationQuery = () => {
  const clientId = useClientId();

  const fpId = useFpId();

  const isPdf = useIsPdf();

  return useQuery(
    queryKeys.estatePlanningExplanation(clientId, fpId, isPdf),

    () => fetchEstatePlanningExplanation({ clientId, fpId, isPdf }),

    {
      enabled: !!fpId,
      cacheTime: 0,
    },
  );
};
